(function () {
  function openHeaderSearch(term) {
    var container = document.querySelector('.site-header__search-container');
    if (container) container.classList.add('is-active');

    document.dispatchEvent(new CustomEvent('predictive-search:open', {
      detail: { context: 'header' },
      bubbles: true
    }));

    var input = document.querySelector('#Search');
    if (!input) return;

    if (typeof term === 'string') input.value = term;
    window.setTimeout(function () {
      input.focus();
    }, 80);
  }

  var compactForm = document.querySelector('.header-search-compact');
  var compactInput = document.querySelector('.js-header-search-compact');

  if (compactForm && compactInput) {
    var openedFromPointer = false;

    compactInput.addEventListener('pointerdown', function () {
      openedFromPointer = true;
    });

    compactInput.addEventListener('focus', function () {
      if (openedFromPointer) return;
      openHeaderSearch(compactInput.value);
    });

    compactInput.addEventListener('pointerup', function () {
      window.setTimeout(function () {
        openedFromPointer = false;
        openHeaderSearch(compactInput.value);
      }, 0);
    });

    compactInput.addEventListener('input', function () {
      var overlayInput = document.querySelector('#Search');
      if (!overlayInput) return;
      overlayInput.value = compactInput.value;
      overlayInput.dispatchEvent(new Event('input', { bubbles: true }));
    });

    compactForm.addEventListener('submit', function (event) {
      event.preventDefault();
      var term = compactInput.value.trim();
      if (!term) {
        openHeaderSearch('');
        return;
      }

      var action = compactForm.getAttribute('action') || '/search';
      var separator = action.indexOf('?') === -1 ? '?' : '&';
      window.location.href = action + separator + 'q=' + encodeURIComponent(term) + '&options[prefix]=last';
    });
  }

  var desktopQuery = window.matchMedia('(min-width: 769px)');

  function syncFeaturedCarousel(el, attempts) {
    if (!el || !window.Flickity) return;
    var desktopOn = el.getAttribute('data-desktop-carousel') === 'true';
    var mobileOn = el.getAttribute('data-mobile-carousel') === 'true';
    var mode = desktopQuery.matches ? (desktopOn ? 'desktop' : '') : (mobileOn ? 'mobile' : '');
    var existing = Flickity.data(el);

    if (!mode) {
      if (existing) existing.destroy();
      el.removeAttribute('data-carousel-mode');
      return;
    }

    if (el.offsetWidth === 0) {
      if ((attempts || 0) >= 20) return;
      window.setTimeout(function () {
        syncFeaturedCarousel(el, (attempts || 0) + 1);
      }, 80);
      return;
    }

    if (existing && el.getAttribute('data-carousel-mode') === mode) {
      existing.resize();
      return;
    }

    if (existing) existing.destroy();

    var perRow = mode === 'desktop' ? (parseInt(el.getAttribute('data-per-row'), 10) || 4) : 1;
    var count = el.querySelectorAll('.featured-collection__item').length;
    if (!count) return;
    var canLoop = count > perRow;

    el.setAttribute('data-carousel-mode', mode);

    new Flickity(el, {
      cellSelector: '.featured-collection__item',
      prevNextButtons: canLoop,
      pageDots: false,
      wrapAround: canLoop,
      cellAlign: 'left',
      contain: true,
      adaptiveHeight: false,
      draggable: true,
      dragThreshold: 12
    });

    el.querySelectorAll('img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', function () {
        var instance = Flickity.data(el);
        if (instance) instance.resize();
      }, { once: true });
    });
  }

  function initFeaturedCarousels(scope) {
    (scope || document).querySelectorAll('[data-featured-carousel]').forEach(function (el) {
      syncFeaturedCarousel(el);
    });
  }

  function initDependCards(scope) {
    (scope || document).querySelectorAll('[data-depend-card]').forEach(function (card) {
      if (card.getAttribute('data-depend-ready') === 'true') return;
      card.setAttribute('data-depend-ready', 'true');

      card.addEventListener('pointerdown', function (event) {
        if (event.target.closest('button, a')) event.stopPropagation();
      });
    });
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-size-trigger]');
    if (!button) return;
    var card = button.closest('[data-depend-card]');
    if (!card) return;

    var size = button.getAttribute('data-size-trigger');
    card.querySelectorAll('[data-size-trigger]').forEach(function (el) {
      var active = el === button;
      el.classList.toggle('is-active', active);
      el.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    card.querySelectorAll('[data-size-panel]').forEach(function (panel) {
      panel.hidden = panel.getAttribute('data-size-panel') !== size;
    });
    var image = card.querySelector('[data-card-image]');
    var nextSrc = button.getAttribute('data-image');
    if (image && nextSrc) {
      image.setAttribute('src', nextSrc);
      image.setAttribute('srcset', nextSrc + ' 800w');
    }
  });

  function showCardError(button, message) {
    var offer = button.closest('.depend-card__offer');
    var error = offer && offer.querySelector('[data-depend-error]');
    if (!error) return;
    error.hidden = !message;
    error.textContent = message || '';
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-depend-add]');
    if (!button || button.disabled || button.getAttribute('data-pending') === 'true') return;
    event.preventDefault();

    var variantId = button.getAttribute('data-variant-id');
    if (!variantId || !window.theme || !theme.routes || !theme.routes.cartAdd) return;

    button.setAttribute('data-pending', 'true');
    button.classList.add('is-loading');
    showCardError(button, '');

    fetch(theme.routes.cartAdd, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }]
      })
    })
      .then(function (response) {
        return response.json().then(function (data) {
          return { ok: response.ok, data: data };
        });
      })
      .then(function (result) {
        button.setAttribute('data-pending', 'false');
        button.classList.remove('is-loading');
        if (!result.ok || result.data.status) {
          var message = result.data.description || result.data.message || 'No se pudo agregar el producto.';
          if (typeof message !== 'string') message = 'No se pudo agregar el producto.';
          showCardError(button, message);
          return;
        }

        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
          return;
        }

        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: { product: result.data, addToCartBtn: button }
        }));

        if (!theme.settings || theme.settings.cartType !== 'drawer') {
          window.location.href = theme.routes.cartPage;
        }
      })
      .catch(function () {
        button.setAttribute('data-pending', 'false');
        button.classList.remove('is-loading');
        showCardError(button, 'No se pudo agregar el producto.');
      });
  });

  function bootFeaturedCollection(scope) {
    initDependCards(scope);
    initFeaturedCarousels(scope);
  }

  bootFeaturedCollection(document);

  if (desktopQuery.addEventListener) {
    desktopQuery.addEventListener('change', function () {
      initFeaturedCarousels(document);
    });
  }

  document.addEventListener('shopify:section:load', function (event) {
    bootFeaturedCollection(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!window.Flickity) return;
    event.target.querySelectorAll('[data-featured-carousel]').forEach(function (el) {
      var existing = Flickity.data(el);
      if (existing) existing.destroy();
    });
  });
})();
